export type ProcessingTypeView = "all-requests" | "helmets";

export const ProcessingTypeViews: {
  AllRequests: ProcessingTypeView;
  Helmets: ProcessingTypeView;
} = {
  AllRequests: "all-requests",
  Helmets: "helmets",
};

export type ProcessingType = {
  id: string;
  name: string;
  showMarketingFields: boolean;
  // isKitRequest: boolean;
  allowQuantityVariation: boolean;
  initialItemIsFinalItem: boolean;
  views: string[];
};

export type SearchProcessingTypeResponse = {
  items: ProcessingType[];
  total: number;
  views: string[];
};

export type UpsertProcessingType = {
  name: string;
  showMarketingFields: boolean;
  // isKitRequest: boolean;
  allowQuantityVariation: boolean;
  initialItemIsFinalItem: boolean;
  views: string[];
};
